import * as service from './OrganizationDetails.service.js'

export default {
  data() {
    return {
      ActionsColumns: ['Name', 'Description', 'Actions'],
      actionstable: {

        headings: {
          Name: 'Name',
          Description: 'Description',
          edit: 'Edit',
          delete: 'Delete',
          Actions: ''

        },
        sortIcon: {
          base: 'glyphicon',
          up: 'glyphicon-chevron-up',
          down: 'glyphicon-chevron-down'
        },
        sortable: ['Name', 'Description'],
        texts: {

          filterPlaceholder: 'Search...',
          limit: 'Records:',
          noResults: 'No matching records',

        },
        sortable: [],

      },

      Certificationcolumns: ['Name', 'Description', 'Actions'],
      optionstable: {

        headings: {
          Name: 'Name',
          Description: 'Description',
          edit: 'Edit',
          delete: 'Delete',
          Actions: ''

        },
        sortIcon: {
          base: 'glyphicon',
          up: 'glyphicon-chevron-up',
          down: 'glyphicon-chevron-down'
        },
        sortable: ['Name', 'Description'],
        texts: {

          filterPlaceholder: 'Search...',
          limit: 'Records:',
          noResults: 'No matching records',

        },
        sortable: [],

      },
      CertificationTypes: [],
      AddCertificateForm: {

        Name: '',
        Description: '',
        IsActive: true,
        IssuedBy: '',
        ExpiryPeriod: '',
        ExpiryPeriodStatus: 'd'
      },

      DisciplineForm: {

        Name: '',
        Description: ''
      },

      IsCertificateTypeEdit: false,
      period: 'd',
      CertificateTypeEditID: 0,
      organizationDetails: {},
      locations: [],
      pools: [],
      DisciplinaryAction: [],
      locationName: '',
      poolName: '',
      selectedlocationId: '',
      selectedpoolId: '',
      editLocation: false,
      editPool: false,
      currentLocationName: '',
      currentPoolName: '',
      act: false,
      poolpromptVisible: false,
      locationpromptVisible: false,
      positionpromptVisible: false,
      IsDiscEdit: false,

      organizationName: '',
      locationFlag: false,
      orgEditorgEdit: false,
      tabName: 'first',
      position: '',
      positions: [],
      roles: [],
      editPosition: false,
      selectedpositionId: '',
      currentPositionName: '',
      roleModel: '',
      modalTitle: '',
      options: [{
        value: 'PDT',
        label: 'PDT'
      }, {
        value: 'MDT',
        label: 'MDT'
      }, {
        value: 'CDT',
        label: 'CDT'
      }, {
        value: 'EDT',
        label: 'EDT'
      }],
      Timezone: '',
      pdays: [],
      cdays: '',
      Timezoneselected: ''
    }
  },

  mounted() {

    this.pdays = [{
        value: 'd',
        label: 'Days'
      },
      {
        value: 'm',
        label: 'Months'
      },
      {
        value: 'y',
        label: 'Years'
      }
    ]
    this.organizationDetails = {
      organizationId: authDetails.OrganizationId,
      organizationName: authDetails.OrganizationName
    }
    this.getLocations()
    this.getPositions()
    this.getRoles()
    this.GetDisciplinaryActions()
    this.GetCertificationTypes()
  },

  methods: {
    checkNumber() {
      let context = this
      setTimeout(function () {
        context.AddCertificateForm.ExpiryPeriod = context.AddCertificateForm.ExpiryPeriod.replace(/[^0-9]/g, '')
      }, 10)

    },
    changeMonth(per) {

      if (per == 'y') {
        this.cdays = this.AddCertificateForm.ExpiryPeriod * 365
      } else if (per == 'm') {
        this.cdays = this.AddCertificateForm.ExpiryPeriod * 30
      } else {
        this.cdays = per
      }

    },

    showactions() {
      this.IsDiscEdit = false
      this.DisciplineForm = {
        Name: '',
        Description: '',
        IsActive: true,
        IssuedBy: '',
        ExpiryPeriod: '',
        ExpiryPeriodStatus: 'd'
      }
      $('#AddEventsmodel').modal('show')
    },
    showcertificate() {

      let context = this
      this.modalTitle = 'Add Certificate Type'
      $('#AddCertificatemodel').modal('show')

      setTimeout(function () {
        context.$refs['AddCertificateForm'].resetFields()
      }, 10)
    },

    delDis: function (data) {

      var ID = data.row.Id

      let context = this
      context.$confirm('Are you sure you want to delete?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {

        loader.startLoader()
        service.DeleteDisciplinaryAction(ID).then(function (response) {

          context.GetDisciplinaryActions()

          loader.stopLoader()

          context.$notify({
            title: 'Success',
            message: 'Disciplinary Action deleted',
            type: 'success'
          })

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })
        // context.$message({
        //   type: 'success',
        //   message: 'Delete completed'
        // });
      }).catch(() => {

      })

    },

    del: function (data) {

      var ID = data.row.Id

      let context = this
      context.$confirm('Are you sure you want to delete?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {

        loader.startLoader()
        service.DeleteCertificationType(ID).then(function (response) {

          context.GetCertificationTypes()

          loader.stopLoader()

          context.$notify({
            title: 'Success',
            message: 'Deleted Successfully',
            type: 'success'
          })

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })
        // context.$message({
        //   type: 'success',
        //   message: 'Delete completed'
        // });
      }).catch(() => {

      })

    },

    cancelpopup: function () {
      this.IsCertificateTypeEdit = false
      $('#AddCertificatemodel').modal('hide')
    },

    editDiscip(data) {
      this.IsDiscEdit = true
      this.DisciplineForm['Id'] = data.row.Id

      this.DisciplineForm = data.row

      $('#AddEventsmodel').modal('show')
    },

    EditCertificateType: function (data) {
      let context = this
      var ID = this.CertificateTypeEditID
      if (ID !== 0) {
        if (context.AddCertificateForm.ExpiryPeriodStatus == 'y') {
          context.cdays = context.AddCertificateForm.ExpiryPeriod * 365
        } else if (context.AddCertificateForm.ExpiryPeriodStatus == 'm') {
          context.cdays = context.AddCertificateForm.ExpiryPeriod * 30
        } else {
          context.cdays = context.AddCertificateForm.ExpiryPeriod
        }

        let model = {
          Id: ID,
          Name: context.AddCertificateForm.Name,
          Description: context.AddCertificateForm.Description,
          IsActive: context.AddCertificateForm.IsActive,
          IssuedBy: context.AddCertificateForm.IssuedBy,
          ExpiryPeriod: context.cdays,
          ExpiryPeriodStatus: context.AddCertificateForm.ExpiryPeriodStatus
        }
        loader.startLoader()
        service.UpdateCertificationType(model).then(function (response) {
          context.IsCertificateTypeEdit = false
          $('#AddCertificatemodel').modal('hide')
          context.CertificateTypeEditID = 0

          context.$notify({
            title: 'Success',
            message: 'Updated certificate type succesfully',
            type: 'success'
          })
          context.GetCertificationTypes()
          /*  for (var i = 0; i < context.CertificationTypes.length; i++) {
           if (context.CertificationTypes[i].Id == ID) {

           context.CertificationTypes[i].Name = data.Name

           context.CertificationTypes[i].Description = data.Description
           break
           }
           }*/

          loader.stopLoader()

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })

      }


    },

    editcol: function (data) {

      var ID = data.row.Id

      let context = this
      this.modalTitle = 'Edit Certificate Type'
      context.CertificateTypeEditID = ID
      /* for (var i = 0; i < context.CertificationTypes.length; i++) {
       if (context.CertificationTypes[i].Id == data.row.Id) {
       context.AddCertificateForm.Name = data.row.Name

       context.AddCertificateForm.Description = data.row.Description
       context.AddCertificateForm.IsActive = data.row.IsActive
       context.AddCertificateForm.IssuedBy = data.row.IssuedBy
       context.AddCertificateForm.ExpiryPeriod = data.row.ExpiryPeriod
       context.AddCertificateForm.ExpiryPeriodStatus = data.row.ExpiryPeriodStatus
       break
       }
       }*/
      context.AddCertificateForm = deepcopy(data.row)

      if (context.AddCertificateForm.ExpiryPeriodStatus == 'y') {
        context.AddCertificateForm.ExpiryPeriod = context.AddCertificateForm.ExpiryPeriod / 365
      } else if (context.AddCertificateForm.ExpiryPeriodStatus == 'm') {
        context.AddCertificateForm.ExpiryPeriod = context.AddCertificateForm.ExpiryPeriod / 30
      } else {
        context.AddCertificateForm.ExpiryPeriod = context.AddCertificateForm.ExpiryPeriod
      }

      context.IsCertificateTypeEdit = true

      $('#AddCertificatemodel').modal('show')

    },

    GetCertificationTypes() {
      let context = this
      loader.startLoader()
      service.GetCertificationTypes().then(function (response) {

        context.CertificationTypes = response
        if (response) {
          tooltip.startTooltip(50)
        }
        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })

    },

    GetDisciplinaryActions() {
      let context = this
      loader.startLoader()
      service.GetDisciplinaryActions().then(function (response) {

        context.DisciplinaryAction = response ? response : []
        if (response) {
          tooltip.startTooltip(50)
        }
        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })

    },

    updateDiscipline(formName) {
      let context = this

      this.$refs[formName].validate((valid) => {


        if (valid) {

          let context = this
          loader.startLoader()


          service.UpdateDisciplinaryAction(context.DisciplineForm).then(function (response) {

            loader.stopLoader()
            $('#AddEventsmodel').modal('hide')
            context.$notify({

              title: 'Success',

              message: 'Disciplinary Action updated',

              type: 'success'

            })
            context.GetDisciplinaryActions()

          }, (error) => {

            loader.stopLoader()
            $('#AddEventsmodel').modal('hide')
            this.$notify({

              title: 'Error',

              message: error.responseJSON.Message,

              type: 'error'

            })
          })

        } else {
          this.$notify({

            title: 'Error',

            message: 'ORG - 1 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },

    submitDiscipline(formName) {
      let context = this

      this.$refs[formName].validate((valid) => {


        if (valid) {

          let context = this
          loader.startLoader()


          service.AddDisciplinaryAction(context.DisciplineForm).then(function (response) {

            loader.stopLoader()
            $('#AddEventsmodel').modal('hide')
            context.GetDisciplinaryActions()
            context.$notify({

              title: 'Success',

              message: 'Disciplinary Action created',

              type: 'success'

            })

          }, (error) => {

            loader.stopLoader()
            $('#AddEventsmodel').modal('hide')
            this.$notify({

              title: 'Error',

              message: error.responseJSON.Message,

              type: 'error'

            })
          })

        } else {
          this.$notify({

            title: 'Error',

            message: 'ORG -2 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },

    submitForm(formName) {
      let context = this

      this.$refs[formName].validate((valid) => {


        if (valid) {

          loader.startLoader()

          if (context.AddCertificateForm.ExpiryPeriod) {

            if (context.AddCertificateForm.ExpiryPeriodStatus == 'y') {
              context.cdays = context.AddCertificateForm.ExpiryPeriod * 365
            } else if (context.AddCertificateForm.ExpiryPeriodStatus == 'm') {
              context.cdays = context.AddCertificateForm.ExpiryPeriod * 30
            } else {
              context.cdays = context.AddCertificateForm.ExpiryPeriod
            }
          }
          let Model = {

            Name: context.AddCertificateForm.Name,
            Description: context.AddCertificateForm.Description,
            IsActive: context.AddCertificateForm.IsActive,
            IssuedBy: context.AddCertificateForm.IssuedBy,
            ExpiryPeriod: context.cdays,
            ExpiryPeriodStatus: context.AddCertificateForm.ExpiryPeriodStatus
          }

          service.AddCertificationType(Model).then(function (response) {

            loader.stopLoader()
            $('#AddCertificatemodel').modal('hide')
            context.GetCertificationTypes()

          }, (error) => {

            loader.stopLoader()
            $('#AddCertificatemodel').modal('hide')
            this.$notify({

              title: 'Error',

              message: error.responseJSON.Message,

              type: 'error'

            })
          })

        } else {
          this.$notify({

            title: 'Error',

            message: 'ORG -3 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    checkSpace() {

      if (this.organizationName) {
        this.organizationName = this.organizationName.replace(/^\s+|\s+$/g, '')

      }

      if (this.locationName) {
        this.locationName = this.locationName.replace(/^\s+|\s+$/g, '')
      }
      if (this.currentLocationName) {
        this.currentLocationName = this.currentLocationName.replace(/^\s+|\s+$/g, '')
      }
      if (this.poolName) {
        this.poolName = this.poolName.replace(/^\s+|\s+$/g, '')
      }
      if (this.currentPoolName) {
        this.currentPoolName = this.currentPoolName.replace(/^\s+|\s+$/g, '')
      }
      if (this.position) {
        this.position = this.position.replace(/^\s+|\s+$/g, '')
      }
      if (this.currentPositionName) {
        this.currentPositionName = this.currentPositionName.replace(/^\s+|\s+$/g, '')
      }
    },

    UpdateOrganization() {
      let context = this
      loader.startLoader()
      service.UpdateOrganization({
        OrganizationId: authDetails.OrganizationId,
        OrganizationName: this.organizationName
      }).then(function (response) {
        authDetails.OrganizationName = context.organizationName
        context.organizationDetails.organizationName = context.organizationName
        context.$localStorage.set('authentication', JSON.stringify(authDetails))
        context.orgEditorgEdit = false
        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })

    },

    DeletePosition(positionId) {
      let context = this

      this.$confirm('This will permanently delete the position. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {

        loader.startLoader()

        service.DeletePosition(positionId).then(function (response) {

          for (var i = 0; i < context.positions.length; i++) {

            if (context.positions[i].PositionId == positionId) {
              context.positions.splice(i, 1)
              i--
            }
          }
          context.$notify({

            title: 'Success',

            message: 'Position deleted',

            type: 'success'

          })
          loader.stopLoader()

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })

      }).catch(() => {

      })
    },

    updateRole(positionId, roleId, positionName) {
      let context = this

      let positionModel = {
        PositionId: positionId,
        RoleId: roleId,
        PositionName: positionName

      }
      let cfinish = false
      let i = 0

      let resTime = setInterval(function () {
        i = i++
          if (i > 10 && !cfinish) {
            loader.startLoader()
            clearInterval(resTime)
          }

      }, 10)

      service.updateRole(positionModel).then(function (response) {

        cfinish = true
        clearInterval(resTime)

        for (var i = 0; i < context.positions.length; i++) {

          if (context.positions[i].PositionId == positionId) {
            context.positions[i].PositionName = positionName
            context.currentPositionName = positionName
            context.selectedpositionId = ''
            context.editPosition = false
          }
        }

        loader.stopLoader()

      }, (error) => {
        cfinish = true
        clearInterval(resTime)
        loader.stopLoader()
        context.currentPositionName = positionName
        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })
    },
    addPosition() {
      let context = this
      loader.startLoader()

      let positionModel = {

        PositionName: this.position

      }

      service.AddPosition(positionModel).then(function (response) {

        if (!context.positions) {
          context.positions = []
        }

        context.positions.push({
          PositionId: response[0].PositionId,
          PositionName: context.position,
          RoleId: response[0].RoleId,
          RoleName: response[0].RoleName
        })

        context.position = ''
        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })
    },
    getLocations() {
      let context = this
      loader.startLoader()
      service.GetLocations().then(function (response) {

        context.locations = response
        if (response) {
          if (response.length > 0) {
            setTimeout(function () {

              context.$refs.locationTable.setCurrentRow(context.locations[0])

            }, 500)

            context.getPools(response[0].LocationId)
            context.selectedlocationId = response[0].LocationId
            context.currentLocationName = response[0].LocationName
          }
        }

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.error_description,

          type: 'error'

        })
      })

    },
    getPositions() {
      let context = this
      loader.startLoader()
      service.GetPositions().then(function (response) {

        context.positions = response

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.error_description,

          type: 'error'

        })
      })

    },
    getRoles() {
      let context = this
      loader.startLoader()
      service.GetRoles().then(function (response) {
        window.xt = JSON.stringify(response)

        context.roles = response

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.error_description,

          type: 'error'

        })
      })

    },
    getPools(locationId) {
      this.poolName = ''
      let context = this
      let cfinish = false
      let i = 0

      let resTime = setInterval(function () {
        i = i++

          if (i > 10 && !cfinish) {
            loader.startLoader()
            clearInterval(resTime)
          }

      }, 10)

      service.GetPoolsById(locationId).then(function (response) {
        cfinish = true
        context.pools = response
        clearInterval(resTime)
        if (response) {
          if (response.length > 0) {

            context.selectedpoolId = response[0].PoolId
            context.currentPoolName = response[0].PoolName
          }
        }

        loader.stopLoader()

      }, (error) => {
        cfinish = true
        clearInterval(resTime)
        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.error_description,

          type: 'error'

        })
      })

    },
    addPool() {
      let context = this
      loader.startLoader()

      service.AddPool({
        PoolName: this.poolName,
        LocationId: this.selectedlocationId
      }).then(function (response) {

        if (!context.pools) {
          context.pools = []
        }
        context.pools.push({
          PoolId: response.PoolId,
          PoolName: context.poolName
        })
        context.$router.app.$emit('invokePoolLoc')

        context.poolName = ''

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })
    },
    UpdatePool(poolid, poolname) {

      let context = this

      loader.startLoader()
      service.UpdatePool({
        PoolId: poolid,
        PoolName: poolname,
        LocationId: this.selectedlocationId
      }).then(function (response) {
        context.editPool = false
        context.$router.app.$emit('invokePoolLoc')
        for (var i = 0; i < context.pools.length; i++) {

          if (context.pools[i].PoolId == poolid) {
            context.pools[i].PoolName = poolname
            context.currentPoolName = poolname
          }
        }

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()
        context.currentPoolName = poolname
        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })

    },
    DeletePool(poolid) {
      let context = this

      this.$confirm('This will permanently delete the pool. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',

      }).then(() => {

        loader.startLoader()

        service.DeletePool(poolid).then(function (response) {

          context.$router.app.$emit('invokePoolLoc')
          for (var i = 0; i < context.pools.length; i++) {

            if (context.pools[i].PoolId == poolid) {
              context.pools.splice(i, 1)
              i--
            }
          }

          context.$notify({

            title: 'Success',

            message: 'Pool deleted',

            type: 'success'

          })

          loader.stopLoader()

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })

      }).catch(() => {
        /*     this.$message({
         type: 'info',
         message: 'Delete canceled'
         });*/
      })

    },
    DeleteLocation(locationid) {
      let context = this

      this.$confirm('This will permanently delete the location. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {

        loader.startLoader()

        service.DeleteLocation(locationid).then(function (response) {
          context.$router.app.$emit('invokePoolLoc')
          for (var i = 0; i < context.locations.length; i++) {

            if (context.locations[i].LocationId == locationid) {
              context.locations.splice(i, 1)
              i--
            }
          }

          // context.$message({
          //   type: 'success',
          //   message: 'Location deleted'
          // });
          context.$notify({

            title: 'Success',

            message: 'Location deleted',

            type: 'success'

          })
          loader.stopLoader()

        }, (error) => {

          loader.stopLoader()

          this.$notify({

            title: 'Error',

            message: error.responseJSON.Message,

            type: 'error'

          })
        })

      }).catch(() => {

      })

    },
    selectlocationCell(row) {
      if (this.selectedlocationId != row.LocationId) {
        this.getPools(row.LocationId)
        this.editLocation = false
        this.locationFlag = false
      }

      if (this.selectedlocationId == row.LocationId) {
        this.locationFlag = true

      }
      if (!this.locationFlag) {

        this.currentLocationName = row.LocationName
        this.Timezoneselected = row.LocationOffset
      }

      this.selectedlocationId = row.LocationId

    },
    selectpoolCell(row) {

      if (this.selectedpoolId != row.PoolId) {
        this.editPool = false
      }
      this.currentPoolName = row.PoolName
      this.selectedpoolId = row.PoolId

    },

    selectpositionCell(row) {

      //this.currentPositionName = row.PositionName
      // this.selectedpoolId = row.PositionId

    },
    addLocation() {
      let context = this
      loader.startLoader()
      let model = {
        LocationName: this.locationName,
        LocationOffset: this.Timezone
      }
      service.AddLocation(model).then(function (response) {
        context.$router.app.$emit('invokePoolLoc')

        if (!context.locations) {
          context.locations = []
        } else {

          context.locations.push({
            LocationId: response.LocationId,
            LocationName: context.locationName,
            LocationOffset: context.Timezone
          })
          context.locationName = ''
          context.Timezone = ''
        }

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()

        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })

    },
    UpdateLocation(locationid, locationname, Timezone) {
      let context = this

      loader.startLoader()
      service.UpdateLocation({
        LocationId: locationid,
        LocationName: locationname,
        LocationOffset: Timezone
      }).then(function (response) {
        context.editLocation = false
        context.$router.app.$emit('invokePoolLoc')
        for (var i = 0; i < context.locations.length; i++) {

          if (context.locations[i].LocationId == locationid) {
            context.locations[i].LocationName = locationname
            context.locations[i].LocationOffset = Timezone
            context.currentLocationName = locationname,
              context.LocationOffset = Timezone
          }
        }

        loader.stopLoader()

      }, (error) => {

        loader.stopLoader()
        context.currentLocationName = locationname
        this.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
      })

    },

    handleCurrentChange(item) {

    },

  }

}



// WEBPACK FOOTER //
// ./src/pages/OrganizationDetails/OrganizationDetails.controller.js